import { render, staticRenderFns } from "./notifications.vue?vue&type=template&id=89fa623a&"
import script from "./notifications.vue?vue&type=script&lang=ts&"
export * from "./notifications.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports